import { render, staticRenderFns } from "./tabBlog.vue?vue&type=template&id=716e717f"
import script from "./tabBlog.vue?vue&type=script&lang=js"
export * from "./tabBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports